import { Colors } from '@ab-core/colors';
import styled from 'styled-components';

export const NewValue = styled.span`
    color: ${Colors.primary};
    white-space: nowrap;
`;
